import { pasteOptionPanelText } from './PasteOption.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import getButtons from '../plugin/getButtons';
import PasteOptionPlugin from '../plugin/PasteOptionPlugin';
import PasteOptionButton from '../store/schema/PasteOptionButton';
import PasteOptionViewState from '../store/schema/PasteOptionViewState';
import setPasteOptionSelectedIndex from '../actions/setPasteOptionSelectedIndex';

import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';

const styles = require('./PasteOption.scss');
const classNames = require('classnames/bind').bind(styles);

export interface PasteOptionProps {
    viewState: PasteOptionViewState;
    plugin: LazyPlugin<PasteOptionPlugin>;
}

@observer
export default class PasteOption extends React.Component<PasteOptionProps, {}> {
    private buttonPane: HTMLElement;

    render() {
        let { position, subMenuSelectionIndex } = this.props.viewState;
        return (
            position && (
                <Callout
                    gapSpace={10}
                    isBeakVisible={false}
                    target={position}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    directionalHintForRTL={DirectionalHint.bottomRightEdge}
                    preventDismissOnScroll={true}
                    onDismiss={this.onDismiss}>
                    <div ref={this.setButtonPaneRef} className={styles.pastePane}>
                        <div onClick={this.showSubMenu} className={styles.optionPane}>
                            <Icon iconName={'Paste'} className={styles.icon} />
                            {loc(pasteOptionPanelText)}
                        </div>
                        {subMenuSelectionIndex >= 0 && (
                            <div>
                                {getButtons().map((button, i) => (
                                    <IconButton
                                        key={button.key}
                                        className={classNames(styles.button, {
                                            isChecked: subMenuSelectionIndex == i,
                                        })}
                                        onClick={this.getOnButtonCallback(button)}
                                        title={
                                            button.title +
                                            (button.shortcut ? ` (${button.shortcut})` : '')
                                        }
                                        iconProps={{ iconName: button.icon }}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </Callout>
            )
        );
    }

    private setButtonPaneRef = (ref: HTMLDivElement) => {
        this.buttonPane = ref;
    };

    private getOnButtonCallback = (button: PasteOptionButton): (() => void) => {
        return () => {
            this.getPlugin(plugin => plugin.paste(button.key));
        };
    };

    private onDismiss = (evt: any) => {
        let target =
            evt instanceof FocusEvent && evt.relatedTarget instanceof Node
                ? evt.relatedTarget
                : null;
        let clickOnButtonPane =
            target &&
            this.buttonPane &&
            (this.buttonPane == target || this.buttonPane.contains(target));

        if (!clickOnButtonPane) {
            this.getPlugin(plugin => plugin.dismiss());
        }
    };

    private showSubMenu = () => {
        let { viewState } = this.props;
        if (viewState.subMenuSelectionIndex < 0) {
            setPasteOptionSelectedIndex(this.props.viewState, 0);
        }
    };

    private getPlugin(callback: (plugin: PasteOptionPlugin) => void) {
        if (this.props.plugin) {
            this.props.plugin.getPlugin().then(callback);
        }
    }
}
